import { useEffect, useState } from 'react';
import { BlockStack, Button, Card, Modal, Text } from '@shopify/polaris';
import { withRouter } from 'react-router';
import { reqGetNewUserPricingPlanList, reqGetSubscription } from "../../api";
import Language from "../../i18n/Language";
import "./index.scss";
import { store } from '../../redux/store';
import { computeBestDiscount } from '../../utils/planRateCalc';

const t = Language;

const ExclusiveOfferModal = (props) => {
    const {
        openState,
        isComboUser,

        cioPlanDataSet,
        getPageDataRedux,
        handleOpenCwComboModal,
        handleToggleEOfferModal,
        toggleToast,
    } = props;

    const timeArr = [];

    const [open, setOpen] = useState(false);  // 弹窗是否打开
    const [planLoading, setPlanLoading] = useState(true);  // 价格方案加载状态
    const [paidLoading, setPaidLoading] = useState(false);  // 支付加载状态
    const [userlevel, setUserlevel] = useState(1);  // 用户等级
    const [planInfoData, setPlanInfoData] = useState({
        pro: {},
        pre: {},
    });  // 预选方案
    const [planType, setPlanType] = useState('');  // 方案类型
    const [planResData, setPlanResData] = useState({});  // 价格方案数据
    const [totalDiscount, setTotalDiscount] = useState(0);  // 总折扣
    const [discountHours, setDiscountHours] = useState(2);  // 折扣小时
    const [timeLeft, setTimeLeft] = useState({
        hours: '00',
        minutes: '00',
        seconds: '00',
        finished: false
    });

    // 检查图标
    const checkIcon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 9L7.5 12L13.5 6" stroke="var(--color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

    // 背景图标
    const backgroundIcon = <span className='background-icon'>
        <svg width="72" height="70" viewBox="0 0 72 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M66.1738 49.019C71.9132 45.4993 73.7198 38.0051 70.2091 32.2803L68.6199 29.6888C67.7422 28.2576 65.8615 27.8725 64.2185 28.2358C60.5204 29.0534 56.5556 27.5052 54.469 24.1027C52.3824 20.7002 52.8003 16.4644 55.2057 13.539C56.2744 12.2393 56.7839 10.3885 55.9062 8.95724L54.317 6.36579C50.8062 0.640922 43.3075 -1.14675 37.5682 2.37291L6.39208 21.4916C0.65272 25.0113 -1.15391 32.5055 2.35687 38.2303L3.94607 40.8218C4.82376 42.253 6.70443 42.6381 8.34746 42.2748C12.0455 41.4572 16.0103 43.0054 18.0969 46.4079C20.1835 49.8104 19.7657 54.0462 17.3603 56.9716C16.2915 58.2713 15.782 60.1221 16.6597 61.5534L18.2489 64.1448C21.7597 69.8697 29.2584 71.6573 34.9978 68.1377L66.1738 49.019ZM40.8986 25.2927C39.4637 26.1726 37.5891 25.7257 36.7114 24.2945C35.8337 22.8633 36.2853 20.9897 37.7202 20.1098C39.155 19.2299 41.0297 19.6768 41.9074 21.108C42.7851 22.5393 42.3334 24.4128 40.8986 25.2927ZM30.6585 49.4026C31.5362 50.8338 33.4109 51.2807 34.8458 50.4008C36.2806 49.5209 36.7323 47.6473 35.8546 46.2161C34.9769 44.7849 33.1022 44.338 31.6674 45.2179C30.2325 46.0978 29.7809 47.9713 30.6585 49.4026ZM23.1863 34.4799C21.9599 34.1875 21.2053 32.9569 21.5007 31.7313C21.7962 30.5056 23.0299 29.749 24.2563 30.0414L49.3796 36.0307C50.606 36.3231 51.3607 37.5537 51.0652 38.7793C50.7697 40.005 49.536 40.7616 48.3096 40.4692L23.1863 34.4799Z" fill="#d6defe" fillOpacity="0.25" />
        </svg>
        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M24.0359 8.26068C24.6083 5.78446 23.0699 3.31429 20.6 2.7434L19.4819 2.48498C18.8644 2.34226 18.2629 2.74639 17.9257 3.28468C17.1666 4.49624 15.7004 5.15329 14.2324 4.81398C12.7644 4.47468 11.7352 3.24085 11.5848 1.8191C11.518 1.18742 11.1549 0.560323 10.5374 0.4176L9.41929 0.159178C6.94932 -0.411713 4.48305 1.13286 3.91072 3.60908L0.801797 17.0599C0.22946 19.5361 1.76779 22.0062 4.23776 22.5771L5.35583 22.8356C5.97332 22.9783 6.57483 22.5741 6.91206 22.0359C7.67108 20.8243 9.13733 20.1673 10.6053 20.5066C12.0733 20.8459 13.1025 22.0797 13.2529 23.5014C13.3197 24.1331 13.6829 24.7602 14.3004 24.9029L15.4184 25.1614C17.8884 25.7323 20.3547 24.1877 20.927 21.7115L24.0359 8.26068ZM10.96 8.78073C10.8169 9.39979 10.2003 9.78593 9.58281 9.64321C8.96532 9.50048 8.58074 8.88294 8.72382 8.26389C8.86691 7.64483 9.48348 7.25869 10.101 7.40141C10.7185 7.54413 11.103 8.16168 10.96 8.78073ZM14.7368 17.9191C15.3543 18.0619 15.9708 17.6757 16.1139 17.0567C16.257 16.4376 15.8724 15.8201 15.2549 15.6773C14.6374 15.5346 14.0209 15.9208 13.8778 16.5398C13.7347 17.1589 14.1193 17.7764 14.7368 17.9191ZM8.74298 15.9792C8.33962 16.2318 7.80868 16.1091 7.55709 15.7051C7.3055 15.3011 7.42853 14.7688 7.83188 14.5162L16.0947 9.34135C16.4981 9.08873 17.029 9.21145 17.2806 9.61545C17.5322 10.0194 17.4092 10.5517 17.0058 10.8043L8.74298 15.9792Z" fill="#d6defe" fillOpacity="0.25" />
        </svg>

    </span>

    // 设置弹窗样式
    const changePopoverCss = (isSet = true) => {
        const STYLE_ID = 'exclusive-offer-modal-size-style';
        let styleEl = document.getElementById(STYLE_ID); // 识别唯一id
        if (isSet) {
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = STYLE_ID;
                styleEl.textContent = `
                    .Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge {
                        max-width: 900px;
                    }
                    .Polaris-Tooltip-TooltipOverlay__Content {
                        background-color: #1a1826;
                        color: #fdfdff;
                    }
                    .Polaris-Tooltip-TooltipOverlay .Polaris-Tooltip-TooltipOverlay__Tail,
                    .Polaris-Tooltip-TooltipOverlay .Polaris-Tooltip-TooltipOverlay__Tail path {
                        fill: #1a1826;
                    }
                    .Polaris-Tooltip-TooltipOverlay--wide {
                        max-width: 350px;
                    }
                `;
                document.head.appendChild(styleEl);
            }
        } else {
            setTimeout(() => {
                if (styleEl) {
                    styleEl.remove();
                }
            }, 500)
        }
    }

    // 获取价格方案
    const getPricingPlan = async (isNew = false, type = '') => {
        let _actData = store.getState().public.ActMealData;
        let _page = store.getState().page;
        let cache = _page.pageInit?.pricingPlan;
        if (Object.keys(_actData).length > 0) {
            let params = {
                activity_id: _actData.activity_id,
            };
            let res = cache || await reqGetNewUserPricingPlanList(params);
            if (isNew) {
                res = await reqGetNewUserPricingPlanList(params);
            }
            if (res.ack === 1) {
                getPageDataRedux(res, 'pricingPlan'); // 设置价格缓存数据
                setPlanLoading(false);
                let planInfo = {
                    pro: computeBestDiscount(res.data, res.data.meal_list.month[0]),
                    pre: computeBestDiscount(res.data, res.data.meal_list.month[1]),
                }
                setPlanInfoData(planInfo);
                setTotalDiscount(((1 - planInfo.pro.rate) * 100).toFixed(0));
                setDiscountHours(getRemainingHours(planInfo.pro.expires_in));
                setUserlevel(res.data.level);
                setPlanResData(res.data);

                if (!isNew) {
                    // posthog 弹窗埋点
                    props.cwreportCustomBehavior('guide_entry_exposure', {
                        source_type: "promotion",
                        planRes: res.data,
                        planInfo,
                        selData: (type || planType) === 'pro' ? planInfo.pro : planInfo.pre,
                    });
                }

                // 设置倒计时
                if (planInfo.pro?.expires_in) {
                    if (timeLeft?.finished) return;
                    const timer = setInterval(() => {
                        const updated = getTimeLeft(planInfo.pro.expires_in);
                        setTimeLeft(updated);
                        if (updated.finished) {
                            clearInterval(timer); // 倒计时结束时清理
                            getPricingPlan(true, type); // 获取新价格方案
                        }
                    }, 1000);
                    timeArr.push(timer);
                } else {
                    clearTimeArr();
                }
            } else {
                toggleToast(res.msg, true);
            }

            setPlanLoading(false);
        } else {
            setTimeout(() => {
                getPricingPlan(isNew, type);
            }, 500)
        }
    }

    // 升级方案
    const handleUpgradePlan = async (type = 'pro') => {
        setPaidLoading(type);
        let selData = type === 'pro' ? planInfoData.pro : planInfoData.pre;
        // 判断是否组合付费用户 
        if (isComboUser) {
            setPaidLoading(false);
            handleOpenCwComboModal('showGetMoreUsageModal');  // 打开提示弹窗
        } else {
            // 获取套餐来源
            const _params = {
                source_type: "promotion",
                planRes: planResData,
                planInfo: planInfoData,
                selData,
            }
            let _t = props.handleGetPlanSource('enter_checkout', _params);

            let params = {
                ppid: selData.id,
                price: Number(selData.price),
                is_verify: 0,
                source_type: "promotion",

                source_type: _t.source_type,
                source_position: _t.source_position,
                plan_type: _t.plan_type,
                plan_version: _t.plan_version,
                discount: _t.discount,
                paid_type: _t.paid_type,
            }
            // 活动折扣
            if (selData.rate) {
                params.activity_id = selData.activity_id;
            }
            // 优惠券折扣
            if (selData.code) {
                params.coupon_code = selData.code;
            }
            // cio埋点
            let yPrice = (selData.price / 12).toFixed(2);
            cioPlanDataSet(([2, 4].includes(selData.id) ? 'monthly' : [8, 9].includes(selData.id) ? 'annually' : ''), ([2, 8].includes(selData.id) ? 'Pro Plan' : [4, 9].includes(selData.id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(selData.id) ? yPrice : selData.price));
            // posthog 支付埋点
            props.cwreportCustomBehavior('enter_checkout', _params);
            // 请求
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        handleJumpSubUrl(j_url);
                    }
                }
            } else {
                toggleToast(res.msg, true);
                setPaidLoading(false);
            }
        }
    }

    // 监听支付跳转
    const handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 计算剩余时间
    const getTimeLeft = (target) => {
        const now = Date.now();
        const diff = (target * 1000) - now;

        if (diff <= 0) {
            return { hours: 0, minutes: 0, seconds: 0, finished: true };
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        return {
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
            finished: false
        };
    }

    // 关闭弹窗
    const handleCloseModal = () => {
        setOpen(false);
        handleToggleEOfferModal(false);
        clearTimeArr();
    }

    // 清除倒计时定时器
    const clearTimeArr = () => {
        timeArr.map(timer => {
            clearInterval(timer);
            timeArr.pop();
            return false;
        })
    }

    // 监听弹窗打开更改宽度
    useEffect(() => {
        let _state = Boolean(openState);
        setOpen(_state);
        changePopoverCss(_state);
        setPlanType(openState); // 设置方案类型
        if (_state) {
            getPricingPlan(false, openState);
        }
    }, [openState]);

    // 弹窗内容
    const modalContent = (
        <Modal
            open={open}
            onClose={handleCloseModal}
            size="large"
        >
            <div className='exclusive-offer-modal'>
                {backgroundIcon}
                {/* Header Section */}
                <div className="modal-header">
                    <div className='modal-header-content'>
                        <Text as="h2" variant="headingLg" alignment='center'>🎁 {t("Exclusive Offer Just for You")} —</Text>
                        <div className='total-discount-content'>
                            <span className='total-discount'>{t("Total {{v1}}% OFF!", discountHours <= 0 ? "--" : totalDiscount)}</span>
                            <span className='total-discount-icon'>
                                <svg width="150" height="120" viewBox="0 0 184 159" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M31.3096 34.1217C42.4762 55.2884 87.3096 45.3578 74.8096 28.504C62.3096 11.6502 29.8096 41.5039 85.3096 65.504" stroke="#121217" strokeWidth="4" />
                                    <path d="M77.4546 63.4104C78.0715 59.4789 81.4841 56.599 85.4633 56.6517L108.621 56.9587C110.941 56.9894 113.133 58.025 114.63 59.7979L157.352 110.422C160.201 113.799 159.774 118.846 156.397 121.696L129.649 144.269C126.273 147.118 121.225 146.691 118.376 143.314L75.6536 92.6898C74.1575 90.9169 73.5045 88.582 73.8641 86.2902L77.4546 63.4104ZM87.3814 66.5182C84.4935 68.9553 84.128 73.273 86.5651 76.1609C89.0022 79.0485 93.3193 79.4135 96.2071 76.9765C99.0947 74.5394 99.46 70.223 97.0233 67.3352C94.5862 64.4473 90.2693 64.0813 87.3814 66.5182Z" fill="url(#paint0_linear_221_32715)" />
                                    <path d="M76.9698 66.1342C76.244 62.2213 78.5045 58.3704 82.2747 57.0966L104.216 49.6838C106.414 48.9413 108.826 49.1887 110.827 50.363L167.954 83.8961C171.765 86.1326 173.04 91.0348 170.804 94.8451L153.086 125.029C150.85 128.84 145.948 130.115 142.137 127.879L85.0097 94.3456C83.009 93.1713 81.6166 91.1865 81.1936 88.9055L76.9698 66.1342ZM87.3651 65.7635C85.4522 69.0223 86.5436 73.2157 89.8024 75.1286C93.0612 77.0412 97.2539 75.9496 99.1668 72.6908C101.079 69.4321 99.9883 65.24 96.7298 63.327C93.471 61.4141 89.2781 62.5047 87.3651 65.7635Z" fill="url(#paint1_linear_221_32715)" />
                                    <path d="M88.3096 68.004C92.5736 69.4176 94.7095 69.4818 95.8106 67.5148C97.2944 64.8643 93.6138 59.982 87.5899 56.6098C81.566 53.2376 75.5484 50.004 73.3093 54.0039C72.3161 55.7782 71.8094 59.0039 75.8094 61.0039" stroke="#121217" strokeWidth="4" strokeLinecap="round" />
                                    <path d="M114.918 75.4517C115.207 74.8243 115.225 74.2156 114.972 73.6255C114.718 73.0355 114.21 72.5161 113.445 72.0674C112.926 71.7625 112.444 71.5786 112 71.5156C111.559 71.4478 111.168 71.4852 110.827 71.6278C110.492 71.7733 110.229 72.0077 110.039 72.3312C109.871 72.5949 109.789 72.8632 109.794 73.136C109.803 73.4117 109.875 73.6877 110.009 73.9642C110.147 74.2357 110.328 74.5102 110.554 74.7877C110.783 75.0603 111.039 75.3297 111.325 75.5959L112.487 76.7132C113.058 77.2456 113.545 77.7954 113.95 78.3625C114.355 78.9296 114.654 79.51 114.845 80.1035C115.037 80.6971 115.101 81.3011 115.037 81.9157C114.977 82.5331 114.766 83.1568 114.403 83.7869C113.857 84.7052 113.153 85.3659 112.291 85.7688C111.436 86.1698 110.463 86.3005 109.373 86.1609C108.29 86.0193 107.136 85.589 105.911 84.8699C104.695 84.1566 103.746 83.3491 103.063 82.4475C102.385 81.5487 102.008 80.5862 101.932 79.5598C101.864 78.5314 102.135 77.4686 102.746 76.3713L105.826 78.179C105.564 78.7039 105.461 79.2101 105.517 79.6978C105.581 80.1834 105.779 80.6386 106.109 81.0632C106.448 81.4858 106.891 81.8581 107.44 82.1803C107.979 82.4967 108.493 82.6929 108.982 82.7691C109.476 82.8482 109.915 82.8128 110.299 82.6629C110.684 82.513 110.982 82.2568 111.195 81.8942C111.394 81.5561 111.46 81.2129 111.394 80.8647C111.334 80.5193 111.159 80.1536 110.872 79.7676C110.59 79.3844 110.213 78.9656 109.742 78.5112L108.344 77.1375C107.257 76.0838 106.538 75.013 106.188 73.9249C105.839 72.8369 105.993 71.7382 106.651 70.6287C107.181 69.7144 107.891 69.0606 108.78 68.6671C109.675 68.2765 110.666 68.1432 111.753 68.2672C112.839 68.3912 113.931 68.7754 115.029 69.4196C116.146 70.0754 117.009 70.8389 117.618 71.7101C118.231 72.5841 118.571 73.4983 118.637 74.4527C118.702 75.407 118.48 76.3368 117.968 77.2422L114.918 75.4517ZM116.098 90.5633L112.688 88.5614L126.72 76.5588L130.821 78.9662L127.175 97.065L123.764 95.0632L126.81 81.2368L126.693 81.1678L116.098 90.5633ZM119.358 84.5214L127.414 89.2499L125.955 91.7342L117.9 87.0057L119.358 84.5214ZM128.814 98.0273L137.65 82.9744L140.832 84.8425L133.537 97.2714L139.99 101.059L138.45 103.683L128.814 98.0273ZM140.385 104.819L149.221 89.7664L159.364 95.7203L157.824 98.3442L150.863 94.2585L148.758 97.8453L155.196 101.625L153.656 104.249L147.218 100.469L145.108 104.063L152.098 108.166L150.557 110.79L140.385 104.819Z" fill="white" />
                                    <defs>
                                        <linearGradient id="paint0_linear_221_32715" x1="142.228" y1="133.459" x2="79.7801" y2="54.0179" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#FFAB57" />
                                            <stop offset="1" stopColor="#FFEC21" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_221_32715" x1="161.354" y1="110.651" x2="76.039" y2="56.5029" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#F8874A" />
                                            <stop offset="1" stopColor="#FC5BA5" />
                                        </linearGradient>
                                    </defs>
                                </svg>

                            </span>
                        </div>
                    </div>
                    <div className='countdown_time_container'>
                        <BlockStack gap={200}>
                            {/* 倒计时 */}
                            <div className='countdown_time'>
                                <p>{timeLeft?.hours}</p>
                                <span>:</span>
                                <p>{timeLeft?.minutes}</p>
                                <span>:</span>
                                <p>{timeLeft?.seconds}</p>
                            </div>
                            <Text variant="bodyMd" as="p" tone="subdued">⚡️ {t("But hurry, exclusive offer expires in {{v1}} hours!", discountHours <= 0 ? "--" : discountHours)}</Text>
                        </BlockStack>
                    </div>
                </div>

                {/* Plans Container */}
                <div className="plans-container">
                    {/* Premium Plan */}
                    <div className='trial_plan_box'>
                        <div className='Most_popular'>{t("Most popular")}</div>
                        {/* 渐变背景 */}
                        <div className='trial_plan_bg'></div>
                        <Card>
                            <div className="plan-header">
                                <div className="plan-title">
                                    <Text as="h3" variant="headingMd">{t("Premium Plan")}</Text>
                                    <div className="discount-badge">{t(planInfoData.pre?.rateText)}</div>
                                </div>
                                <div className="pricing">
                                    <h2 className="original-price">${planInfoData.pre?.o_price}</h2>
                                    <h2 className="current-price">${planInfoData.pre?.price} <span>USD</span></h2>
                                </div>
                                <Text as="p" variant="bodyMd" tone="subdued">{t("Everything in Pro, plus")}</Text>
                            </div>

                            <div className="features-list">
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("Content Optimization")} - <span className="bold-text">500 {t("credits/mo")}</span></span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("On-page SEO Audit")} - <span className="bold-text color-text">{t("Unlimited")}</span> <span>{t("pages")}</span></span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span className="bold-text">6000</span>
                                    <span>{t("image compressions/mo")}</span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("Premium Page Speed Optimization")}</span>
                                </div>
                                <div className="feature-item">
                                    {checkIcon}
                                    <span>{t("Competitor Analysis")}</span>
                                </div>
                                {/* <div className="feature-item">
                                    {checkIcon}
                                    <Tooltip
                                        width={'wide'}
                                        content={t("Sync all indexed keywords, track their rankings, and add new keywords for ongoing management.")}
                                    >
                                        <span style={{ textDecorationLine: "underline", textDecorationStyle: "dashed", textDecorationColor: "#ccc", cursor: 'pointer' }}>{t("Keywords Rank Tracker")}</span>
                                    </Tooltip>
                                </div> */}
                            </div>

                            <div className="plan-footer">
                                {
                                    userlevel !== 3 ? <Button size="large" loading={planLoading || (paidLoading === 'pre')} disabled={Boolean(paidLoading)} variant="primary" fullWidth onClick={() => handleUpgradePlan('pre')}>
                                        {planInfoData.pre?.trial_days > 0 ? t("Try Free For {{v1}} Days", planInfoData.pre?.trial_days) : t("Get Premium Now")}
                                    </Button> : <Button size="large" loading={planLoading || (paidLoading === 'pre')} variant="primary" fullWidth disabled>
                                        {t("Current Plan")}
                                    </Button>
                                }

                                {
                                    planInfoData.pre?.trial_days > 0 && planInfoData.pre?.period <= 0 ? <Text as="p" variant="bodySm" tone="subdued">
                                        {t("{{v1}} days free", planInfoData.pre?.trial_days)}
                                    </Text> : planInfoData.pre?.period > 0 ?
                                        <Text as="p" variant="bodySm" tone="subdued">
                                            {

                                                `${planInfoData.pre?.trial_days > 0 ? t("{{v1}} days free, ", planInfoData.pre?.trial_days) : ""}${planInfoData.pre?.period <= 1 ? t("${{v1}} for the first month", planInfoData.pre?.price) : t("${{v1}} for {{v2}} month", planInfoData.pre?.price, planInfoData.pre?.period)}`
                                            }
                                        </Text> : null
                                }
                            </div>
                        </Card>
                    </div>

                    {/* Pro Plan */}
                    <Card>
                        <div className="plan-header">
                            <div className="plan-title">
                                <Text as="h3" variant="headingMd">{t("Pro Plan")}</Text>
                                <div className="discount-badge">{t(planInfoData.pro?.rateText)}</div>
                            </div>
                            <div className="pricing">
                                <h2 className="original-price">${planInfoData.pro?.o_price}</h2>
                                <h2 className="current-price">${planInfoData.pro?.price} <span>USD</span></h2>
                            </div>
                            <Text as="p" variant="bodyMd" tone="subdued">{t("Key Features")}</Text>
                        </div>

                        <div className="features-list">
                            <div className="feature-item">
                                {checkIcon}
                                <span>{t("Content Optimization")} - <span className="bold-text">200 {t("credits/mo")}</span></span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <span>{t("On-page SEO Audit")} - <span className="bold-text">1000 {t("pages")}</span></span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <span className="bold-text">2000</span>
                                <span>{t("image compressions/mo")}</span>
                            </div>
                            <div className="feature-item">
                                {checkIcon}
                                <span>{t("Pro Page Speed Optimization")}</span>
                            </div>
                            <div className="feature-item" style={{ minHeight: '20px' }}>
                                {/* {checkIcon}
                                <Tooltip
                                    width={'wide'}
                                    content={
                                        <div className="pricing_desc_img">
                                            <img src={"/imgs/pricing/desc/KeywordContentPlanner.png"} alt='' />
                                            <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                            <span>{t("Turn one keyword into a complete content strategy with AI-generated topic clusters and page structure.")}</span>
                                        </div>
                                    }
                                >
                                    <span style={{ textDecorationLine: "underline", textDecorationStyle: "dashed", textDecorationColor: "#ccc", cursor: 'pointer', color: 'var(--color-primary)' }}>{t("Keyword Content Planner")}</span>
                                    <span className='new_sign'>{t("NEW")}</span>
                                </Tooltip> */}
                            </div>
                        </div>

                        <div className="plan-footer">
                            {
                                userlevel !== 2 ? <Button size="large" loading={planLoading || (paidLoading === 'pro')} disabled={Boolean(paidLoading)} variant="primary" fullWidth onClick={() => handleUpgradePlan('pro')}>
                                    {planInfoData.pro?.trial_days > 0 ? t("Try Free For {{v1}} Days", planInfoData.pro?.trial_days) : t("Get Pro Now")}
                                </Button> : <Button size="large" loading={planLoading || (paidLoading === 'pro')} variant="primary" fullWidth disabled>
                                    {t("Current Plan")}
                                </Button>
                            }
                            {
                                planInfoData.pro?.trial_days > 0 && planInfoData.pro?.period <= 0 ? <Text as="p" variant="bodySm" tone="subdued">
                                    {t("{{v1}} days free", planInfoData.pro?.trial_days)}
                                </Text> : planInfoData.pro?.period > 0 ?
                                    <Text as="p" variant="bodySm" tone="subdued">
                                        {
                                            `${planInfoData.pro?.trial_days > 0 ? t("{{v1}} days free, ", planInfoData.pro?.trial_days) : ""}${planInfoData.pro?.period <= 1 ? t("${{v1}} for the first month", planInfoData.pro?.price) : t("${{v1}} for {{v2}} month", planInfoData.pro?.price, planInfoData.pro?.period)}`
                                        }
                                    </Text> : null
                            }
                        </div>
                    </Card>
                </div>
            </div>
        </Modal>
    );

    return modalContent;
}

// 时间戳判断剩余多少个小时
function getRemainingHours(targetTimestamp) {
    const now = Date.now();
    const diff = (targetTimestamp * 1000) - now;
    return Math.floor(diff / (1000 * 60 * 60)) + 1;
}

export default withRouter(ExclusiveOfferModal);